/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import type { Store } from '@reduxjs/toolkit';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import type {
  ReducerMap,
  UIModuleState,
  WebMapStateModuleState,
} from '@opengeoweb/store';
import { storeReducerMap, storeMiddlewares } from '@opengeoweb/store';
import { soundingsReducer } from './reducer';
import type { SoundingsModuleState } from './types';

export * as soundingsSelectors from './selectors';
export {
  soundingsReducer,
  soundingsActions,
  initialSoundingsViewState,
} from './reducer';
export type { SoundingsModuleState, SoundingsViewState } from './types';

export const soundingsReducersMap: ReducerMap = {
  soundings: soundingsReducer,
  ...storeReducerMap,
};

const soundingsRootReducer = combineReducers(soundingsReducersMap);

export const createMockStore = (
  mockState?: SoundingsModuleState | WebMapStateModuleState | UIModuleState,
): Store =>
  configureStore({
    reducer: soundingsRootReducer,
    preloadedState: mockState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(storeMiddlewares),
  });
